import { BUCKEYELINK } from "../enums.js"
import BL from "./buckeyelink.js"

const CONTENT_BUCKET = {
    [BUCKEYELINK]: BL
}

export default CONTENT_BUCKET